import { render, staticRenderFns } from "./POSInquiry.vue?vue&type=template&id=237c1eaf&lang=pug"
import script from "./POSInquiry.vue?vue&type=script&lang=js"
export * from "./POSInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports